module.exports = __webpack_public_path__ + "static/media/song_on_spotify_home.72e98865.PNG";